export type PbErrShape = {
  status?: number;
  isAbort?: boolean;
  response?: { message?: string; data?: Record<string, { message?: string }> };
};

const GENERIC_PB_MSG = /^Failed to (update|create|delete) record\.?$/i;

export function commonNetworkMessage(e: PbErrShape): string | undefined {
  if (e.isAbort || e.status === 0) return 'Sin conexión, inténtalo de nuevo';
  if (e.status === 404) return 'Este lead ya no existe';
  return undefined;
}

// Strips PB's opaque "Failed to update record." default so callers can fall
// back to a localized message instead of leaking it into the UI. The hook
// (lead-appeal-validate.pb.js) throws a real Error but PB v0.36 JSVM swallows
// the message and substitutes that generic — see verify-staging.sh `appeals`.
export function specificPbMessage(e: PbErrShape): string | undefined {
  const raw = e.response?.message ?? '';
  return raw && !GENERIC_PB_MSG.test(raw) ? raw : undefined;
}
